import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Input } from "semantic-ui-react";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import InformationTag from "./InformationTag";
import Aux from "../../components/utility/Aux";

class RenameControl extends Component {
  state = {
    /**
     * If true, the user is currently editing the document
     * title
     */
    isEditingDocumentTitle: false,
    /**
     * Current document title (may be unsaved)
     */
    currentlyEnteredDocumentTitle: null
  };

  /**
   * Sets whether the user is currently editing the document title
   */
  setIsEditingDocumentTitle = isEditing => {
    this.setState(
      {
        isEditingDocumentTitle: isEditing,
        currentlyEnteredDocumentTitle: isEditing
          ? this.props.filename
          : this.state.currentlyEnteredDocumentTitle
      },
      () => {
        if (isEditing && this.titleInput) {
          this.titleInput.focus();
        }
      }
    );
  };

  /**
   * Fired when the user has changed his new document title
   */
  changedCurrentlyEnteredDocumentTitle = (_, { value }) => {
    this.setState({
      currentlyEnteredDocumentTitle: value
    });
  };

  /**
   * Fired when a key has been pressed in the document title field
   */
  handleTitleFieldKeyUp = ({ key }) => {
    if (key === "Enter") {
      this.saveDocumentTitle();
    } else if (key === "Escape") {
      this.setIsEditingDocumentTitle(false);
    }
  };

  /**
   * Reference the document title input field
   */
  referenceDocumentTitleInputField = field => {
    this.titleInput = field;
  };

  /**
   * Updates the document title
   */
  saveDocumentTitle = () => {
    this.setIsEditingDocumentTitle(false);
    this.props.saveDocumentTitle(this.state.currentlyEnteredDocumentTitle);
  };

  render() {
    return this.state.isEditingDocumentTitle && !this.props.isReadOnlyMode ? (
      <Aux className="ux-rename-control editing">
        <Input
          placeholder={this.props.intl.formatMessage({
            id: "editor.document.rename.placeholder"
          })}
          value={this.state.currentlyEnteredDocumentTitle}
          onChange={this.changedCurrentlyEnteredDocumentTitle}
          ref={this.referenceDocumentTitleInputField}
          onKeyUp={this.handleTitleFieldKeyUp}
        />
        <Button
          color="blue"
          onClick={this.saveDocumentTitle}
          compact
          size="mini"
        >
          <Icon name="check" />
          <span>
            <FormattedMessage
              id="editor.document.action.save"
              description="Action button to save a updated document property"
            />
          </span>
        </Button>
      </Aux>
    ) : (
      <Aux className="ux-rename-control">
        <Button
          compact
          basic
          disabled={this.props.isReadOnlyMode}
          onClick={() => this.setIsEditingDocumentTitle(true)}
        >
          <h2>
            {this.props.filename || (
              <FormattedMessage
                id="editor.application.title"
                description="Application title for document viewer/editor"
              />
            )}
          </h2>
          {this.props.isReadOnlyMode ? null : <Icon name="pencil" />}
        </Button>
        {this.props.isReadOnlyMode ? (
          <InformationTag tagIdentifier="editor.files.readonly" />
        ) : null}
      </Aux>
    );
  }
}

RenameControl.propTypes = {
  /**
   * intl: intlShape
   * Localization helper provided by react-intl
   */
  intl: intlShape.isRequired,

  /**
   * filename: String
   * Current document filename
   */
  filename: PropTypes.string.isRequired,

  /**
   * True if the editor does not permit any changes to the document
   */
  isReadOnlyMode: PropTypes.bool,

  /**
   * Saves a new document title
   */
  saveDocumentTitle: PropTypes.func.isRequired
};

RenameControl.defaultProps = {
  isReadOnlyMode: false
};

export default injectIntl(RenameControl);



// WEBPACK FOOTER //
// ./src/components/ui/RenameControl.js